module.exports = __webpack_public_path__ + "static/img/nameCard.bce12e9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/anniversary/nameCard.png
// module id = 8v4w
// module chunks = 0